export class Sheet {
  grade: number | null = 0
  name: string = ""
  curriculum_id: number | null = 0
  page_count: number = 0
  question_image_completed: boolean | null = null
  answer_image_completed: boolean | null = null
}
